import { createFileRoute } from "@tanstack/react-router";
import { ArticlePage } from "@/components/ArticlePage";
import { articleSchemas, qaSchema } from "@/lib/seo";

const UPDATED = "2026-10-14";
const ANSWER = "Ja, Shopify eignet sich für viele B2B-Shops. Händlerpreise, geschützte Kundenbereiche und Kauf auf Rechnung lassen sich umsetzen. Die eingebauten B2B-Funktionen von Shopify sind vor allem in Shopify Plus enthalten, für kleinere Händler reichen oft passende Apps oder eine eigene Lösung.";
const SITE = "https://shopify-freelancer.net";
const PATH = "/fragen/shopify-b2b";
const TITLE = "Eignet sich Shopify für B2B?";
const DESCRIPTION = "Shopify für B2B: Händlerpreise, Kundenkonten, Bestellung auf Rechnung und wann Shopify Plus nötig ist. Ehrliche Einordnung vom Shopify Freelancer.";

const faqs = [
  { q: "Kann ich B2B und B2C in einem Shop verkaufen?", a: "Ja. Händler sehen nach dem Login ihre eigenen Preise, normale Kunden den regulären Shop." },
  { q: "Was kostet ein B2B-Shop mit Shopify?", a: "Das hängt von Preislogik und Schnittstellen ab. Einfache Lösungen starten im Rahmen eines wachsenden Shops, größere Projekte liegen höher. Nach einer kurzen Einschätzung nenne ich einen festen Rahmen." },
  { q: "Brauche ich Shopify Plus für B2B?", a: "Nicht zwingend. Für viele Händler reicht der Standardtarif mit passender Erweiterung." },
];

export const Route = createFileRoute("/fragen/shopify-b2b")({
  component: Page,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: `${SITE}${PATH}` },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: `${SITE}${PATH}` }],
    scripts: [
      ...articleSchemas({ title: TITLE, description: DESCRIPTION, path: PATH, faqs, section: "Shopify B2B", updated: UPDATED, breadcrumb: { name: "Fragen", path: "/fragen" } }),
      qaSchema({ question: TITLE, answer: ANSWER, path: PATH, updated: UPDATED }),
    ],
  }),
});

function Page() {
  return (
    <ArticlePage
      kicker="Frage · B2B"
      title={TITLE}
      intro="Kurz gesagt: ja, mit der richtigen Einrichtung. Entscheidend ist, wie Ihre Händler heute bestellen und welche Preise sie sehen sollen."
      source="frage-shopify-b2b"
      answer={ANSWER}
      updated={UPDATED}
      breadcrumb={{ to: "/fragen", label: "Fragen" }}
      sections={[
        { h: "Was B2B-Kunden erwarten", p: [], list: ["Eigene Preise oder Rabatte je Händler", "Login mit Bestellhistorie und schneller Nachbestellung", "Kauf auf Rechnung und Mindestbestellmengen", "Preise netto mit ausgewiesener Steuer"] },
        { h: "Shopify Plus oder Standardtarif?", p: ["Die eingebauten B2B-Funktionen sind Teil von Shopify Plus. Bei wenigen Händlern ist das oft überdimensioniert. Dann reichen Apps oder kleine Erweiterungen im Theme, deutlich günstiger."] },
        { h: "Anbindung an Ihr Lager und die Buchhaltung", p: ["Im B2B zählt der Ablauf nach der Bestellung. Schnittstellen zu Warenwirtschaft oder DATEV sparen Ihnen täglich Handarbeit."] },
      ]}
      faqs={faqs}
      related={[{ to: "/fragen/wann-lohnt-sich-shopify-plus", label: "Wann lohnt sich Shopify Plus?" }, { to: "/shopify-plus", label: "Shopify Plus" }, { to: "/shopify-shop-erstellen-lassen", label: "Shop erstellen lassen" }]}
    />
  );
}
